<script setup>
const $props = defineProps({
    question: {
        type: String,
        required: true
    }
});
</script>

<template>
    <q-expansion-item
        :label="$props.question"
        class="faq-item"
        expand-icon="sym_r_keyboard_arrow_down"
        group="faqs"
        header-class="text-h6 q-px-none q-py-md"
    >
        <div class="text-body1 q-pb-lg q-pr-md">
            <slot/>
        </div>
    </q-expansion-item>
</template>

<style lang="scss" scoped>
// A question is a ruled row rather than a filled card, ruled off from the row above the way a ledger row is, so hover
// colours the question instead of washing the row grey. The focus helper still shows on keyboard focus, which does not
// hover.
.faq-item {
    border-top: 1px solid rgba($grey-7, 0.24);
}

.faq-item :deep(.q-item) {
    transition: color 120ms ease-in-out;

    &:hover {
        color: var(--q-primary);
    }

    &:hover > .q-focus-helper {
        opacity: 0 !important;
    }
}
</style>
